import { render, staticRenderFns } from "./dialogWhatsapp.vue?vue&type=template&id=1401a636&"
import script from "./dialogWhatsapp.vue?vue&type=script&lang=js&"
export * from "./dialogWhatsapp.vue?vue&type=script&lang=js&"
import style0 from "./dialogWhatsapp.vue?vue&type=style&index=0&id=1401a636&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports